// import 'whatwg-fetch' // fetch polyfill
import 'custom-event-polyfill'

import { getPlatformApps } from './precheck'
import { createApp } from 'vue'
import App from './App.vue'
import { router, addRoutes } from './router'
import WujieVue from 'wujie-vue3'
import credentialsFetch from './fetch'
import stores from './stores'
import 'tdesign-vue-next/es/style/index.css'
import lifecycles from './lifecycle'
import components from './global-component'
import tdesignSpriteOnce from './plugins/tdesignSpriteOnce'

import { toLogin } from '@/util/util'
import { getAppUrl } from '@/const/router'

import 'hxhy-note-editor/dist/index.css'
import hxhyNote from 'hxhy-note-editor/dist/hxhy-note-editor.es.js'

// 载入所有svg icon
const requireContext = require.context('./assets/svg-icons', false, /\.svg$/)
requireContext.keys().forEach(requireContext)

// import VConsole from "vconsole";
// const vConsole = new VConsole();

const { setupApp, preloadApp, bus } = WujieVue

bus.$on('toLogin', toLogin)

const degrade = window.localStorage.getItem('degrade') === 'true' || !window.Proxy || !window.CustomElementRegistry
const attrs = {}

/**
 * wujie 注入的自定义 fetch 可能收到字符串或 Request 对象，
 * 统一提取 url 字符串用于判断是否命中子应用地址
 */
const getFetchUrl = (input) => (typeof input === 'string' ? input : input?.url || '')
/**
 * 配置应用，主要是设置默认配置
 * preloadApp、startApp的配置会基于这个配置做覆盖
 */
getPlatformApps()
  .then((data) => {
    addRoutes(data)
    // setupApp 仅针对无界子应用（type=1），type=2 的应用走 iframe 方式不经过无界
    const wujieApps = data.filter((item) => item.type === 1)
    wujieApps.forEach((item) => {
      const appUrl = getAppUrl(item)
      setupApp({
        name: item.projectName,
        url: appUrl,
        attrs,
        exec: false,
        alive: false,
        plugins: [
          // 所有子应用独立去重 TDesign 官方 sprite，不影响其他业务脚本。
          tdesignSpriteOnce,
        ],
        // 引入了的第三方样式不需要添加credentials
        fetch: (input, options) =>
          getFetchUrl(input).includes(appUrl) ? credentialsFetch(input, options) : window.fetch(input, options),
        degrade,
        ...lifecycles,
      })
    })
  })
  .catch((e) => {
    console.error(e)
  })
  .finally(() => {
    createApp(App)
      // .use(TDesign)
      .use(WujieVue)
      // .use(vConsole)
      .use(components)
      .use(router)
      .use(stores)
      .use(hxhyNote)
      .mount('#main-app')
  })
